/* eslint-disable @typescript-eslint/ban-ts-comment */
import {AxiosResponse} from "axios";
import {
    CoreFrontendNotificationDto,
    CoreFrontendNotificationRequestDto,
    CoreFrontendNotificationResults,
    Filter,
    NotificationOperation,
} from "@mm-products/java-multima-framework";
import {taxGuruAxios} from "../../axios";
import { coreFrontendNotificationUrls } from "../../url";
import operation = NotificationOperation.operation;

export const listNotifications = (filter: Filter, toastId?: string): Promise<AxiosResponse<CoreFrontendNotificationResults>> => {
    return taxGuruAxios.post(coreFrontendNotificationUrls.filter, filter, {
        // @ts-ignore
        toastId,
    });
};

export const updateNotification = (
    id: string,
    notification: CoreFrontendNotificationRequestDto,
    toastId?: string
): Promise<AxiosResponse<CoreFrontendNotificationDto>> => {
    // @ts-ignore
    return taxGuruAxios.put(coreFrontendNotificationUrls.update(encodeURIComponent(id)), notification, { toastId });
};
export const deleteNotification = (id: string, toastId?: string): Promise<AxiosResponse<CoreFrontendNotificationDto>> => {
    // @ts-ignore
    return taxGuruAxios.delete(coreFrontendNotificationUrls.delete(encodeURIComponent(id)), { toastId });
};

export const deleteAllNotifications = (ids: Array<string>, toastId?: string): Promise<AxiosResponse<void>> => {
    return performBulkOperation(ids, operation.REMOVE, toastId);
};
export const markAllNotificationsRead = (ids: Array<string>, toastId?: string) => {
    return performBulkOperation(ids, operation.READ, toastId);
};

const performBulkOperation = (ids: Array<string>, operationType: operation, toastId?: string): Promise<AxiosResponse<void>> => {
    const operations = ids.map((id) => {
        const op: NotificationOperation = {
            operation: operationType,
            id: id,
        };
        return op;
    });
    return taxGuruAxios.patch(
        coreFrontendNotificationUrls.bulk,
        { operations },
        {
            // @ts-ignore
            toastId,
        }
    );
};
